import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const navLinks = [
    { label: 'Vorteile', id: 'vorteile' },
    { label: '4 Wochen testen', id: 'vier-wochen', highlight: true },
    { label: 'Über uns', id: 'ueber-uns' },
    { label: 'Stimmen', id: 'testimonials' },
    { label: 'FAQ', id: 'faq' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-white/98 backdrop-blur-md border-b border-gray-100 py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-between">
        <button
          onClick={() => scrollTo('hero')}
          className="cursor-pointer flex-shrink-0 transition-opacity hover:opacity-75"
        >
          <img
            src="https://static.readdy.ai/image/0545d2048ed36ebe53df2dae0c0b43d7/4ab61485feffac5558181f99f1be66f6.png"
            alt="Körperformen Pinneberg"
            className="h-9 w-auto object-contain"
          />
        </button>

        <nav className="hidden md:flex items-center gap-7">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className={`text-xs font-medium tracking-[0.1em] uppercase transition-all duration-200 cursor-pointer whitespace-nowrap ${
                link.highlight
                  ? scrolled
                    ? 'text-[#1A5C3D] font-semibold'
                    : 'text-[#6ED8A0] font-semibold'
                  : scrolled
                  ? 'text-gray-500 hover:text-gray-900'
                  : 'text-white/75 hover:text-white'
              }`}
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              {link.highlight && (
                <span
                  className="inline-block w-1.5 h-1.5 rounded-full mr-1.5 animate-pulse align-middle"
                  style={{ backgroundColor: scrolled ? '#1A5C3D' : '#6ED8A0', marginBottom: '1px' }}
                />
              )}
              {link.label}
            </button>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-4">
          {scrolled && (
            <div className="flex items-center gap-2 mr-1">
              <div className="flex gap-0.5">
                {[1, 2, 3, 4, 5].map((s) => (
                  <div key={s} className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-star-fill text-yellow-500 text-xs"></i>
                  </div>
                ))}
              </div>
              <span className="text-gray-400 text-xs" style={{ fontFamily: 'Inter, sans-serif' }}>
                5,0 · Google
              </span>
            </div>
          )}
          <button
            onClick={() => scrollTo('vier-wochen')}
            className="text-white text-xs font-semibold px-5 py-2.5 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
            style={{ backgroundColor: '#1A5C3D', fontFamily: 'Inter, sans-serif' }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#236B48')}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#1A5C3D')}
          >
            Probetraining sichern
          </button>
        </div>

        <button
          className={`md:hidden cursor-pointer ${scrolled ? 'text-gray-800' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <div className="w-6 h-6 flex items-center justify-center">
            <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </div>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-6 flex flex-col gap-5">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className={`text-xs font-medium tracking-widest uppercase text-left cursor-pointer whitespace-nowrap ${
                link.highlight ? 'text-[#1A5C3D] font-bold' : 'text-gray-600'
              }`}
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              {link.highlight && (
                <span
                  className="inline-block w-1.5 h-1.5 rounded-full mr-1.5 align-middle"
                  style={{ backgroundColor: '#1A5C3D', marginBottom: '1px' }}
                />
              )}
              {link.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('vier-wochen')}
            className="mt-1 text-white text-sm font-semibold px-5 py-3.5 rounded-full cursor-pointer whitespace-nowrap"
            style={{ backgroundColor: '#1A5C3D', fontFamily: 'Inter, sans-serif' }}
          >
            4 Wochen unverbindlich testen
          </button>
        </div>
      )}
    </header>
  );
}
